"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Success = void 0;
/*
 * © 2025 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const Base_1 = require("./Base");
const Success = ({ fill = "#E6E6E6", size = 16, title = "Filter Applied" }) => (react_1.default.createElement(Base_1.Base, { smooth: true, fill: fill, size: size, title: title },
    react_1.default.createElement("path", { d: "M11,4.4L6.8,8.6 5,6.8 3.6,8.2 6.9,11.5 12.4,5.8 11,4.4zM8,1C11.9,1 15,4.1 15,8 15,11.9 11.9,15 8,15 4.1,15 1,11.9 1,8 1,4.1 4.1,1 8,1z" })));
exports.Success = Success;
//# sourceMappingURL=Success.js.map